<div class="tw-bg-white dark:tw-bg-gray-900 tw-rounded-t-xl">
  <!-- Header -->
  <div class="tw-flex tw-items-center tw-justify-between tw-p-4 tw-border-b tw-border-gray-200 dark:tw-border-gray-700">
    <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900 dark:tw-text-gray-100">Upload Files</h3>
    <button (click)="dismiss()" class="tw-text-gray-500 hover:tw-text-gray-700 dark:tw-text-gray-400 dark:hover:tw-text-gray-200">
      <ng-icon name="heroXMark" size="20"></ng-icon>
    </button>
  </div>

  <!-- File List -->
  <div class="tw-max-h-80 tw-overflow-y-auto tw-p-4">
    <div *ngFor="let file of data.files" 
         class="tw-flex tw-items-center tw-justify-between tw-p-3 tw-bg-gray-50 dark:tw-bg-gray-800 tw-rounded-lg tw-mb-3 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-transition-colors">
      
      <div class="tw-flex tw-items-center tw-space-x-3">
        <div class="tw-flex-shrink-0">
          <ng-icon [name]="getFileIcon(file)" size="24" class="tw-text-blue-500 dark:tw-text-blue-400"></ng-icon>
        </div>
        
        <div class="tw-flex-1 tw-min-w-0">
          <p class="tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-100 tw-truncate">{{ file.name }}</p>
          <p class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">{{ formatFileSize(file.size) }}</p>
        </div>
      </div>
      
      <button (click)="removeFile(file)" class="tw-text-red-500 hover:tw-text-red-700 dark:tw-text-red-400 dark:hover:tw-text-red-300 tw-ml-2">
        <ng-icon name="heroTrash" size="16"></ng-icon>
      </button>
    </div>

    <!-- Empty state -->
    <div *ngIf="data.files.length === 0" class="tw-text-center tw-py-8 tw-text-gray-500 dark:tw-text-gray-400">
      <ng-icon name="heroDocumentPlus" size="32" class="tw-mx-auto tw-mb-2 tw-opacity-50"></ng-icon>
      <p>No files selected</p>
    </div>
  </div>

  <!-- Actions -->
  <div class="tw-flex tw-justify-end tw-space-x-3 tw-p-4 tw-border-t tw-border-gray-200 dark:tw-border-gray-700 tw-bg-gray-50 dark:tw-bg-gray-800/50 tw-rounded-b-xl">
    <button (click)="dismiss()" class="tw-px-4 tw-py-2 tw-text-gray-600 dark:tw-text-gray-400 hover:tw-text-gray-800 dark:hover:tw-text-gray-200">
      Cancel
    </button>
    <button  color="primary" (click)="upload()" [disabled]="data.files.length === 0"
            class="tw-px-6 tw-py-2 tw-bg-blue-500 hover:tw-bg-blue-600 tw-text-white tw-rounded-lg disabled:tw-bg-gray-300 disabled:tw-text-gray-500 tw-transition-colors">
      Send {{ data.files.length }} file{{ data.files.length !== 1 ? 's' : '' }}
    </button>
  </div>
</div>